import { useSelector } from "react-redux";
import { deleteUnsubProcessSectionId, selectUnsubProcessSectionIds } from "../../reduxSlices/subjectsSlice";
import { LiaSpinnerSolid } from "react-icons/lia";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import { useState } from "react";
import Modal from "../Modal/Modal";
import useUnsubscribeSection from "../../hooks/useUnsubscribeSection";
import { IInscribedSubject } from "../../types/inscribedSubjects";
import Translatable from "../Translatable/Translatable";
import { useTranslatedText } from "../../contexts/TranslationContext";
import { extraerNombreMateria, extraerSeccion } from "../../utils";

interface IProps {
  subject: IInscribedSubject;
}

export default function BtnUnsuscribeSubject({ subject }: IProps) {
  const unsubscribeSection = useUnsubscribeSection();
  const unsubProcessSectionIds = useSelector(selectUnsubProcessSectionIds);
  const [open, setOpen] = useState(false);

  const isProcessing = unsubProcessSectionIds.some((item) => item.idCurso === subject.idCurso && item.anioLectivo === subject.anioLectivo);

  const confirmIntro = useTranslatedText("¿Estás seguro que querés desinscribirte de");
  const subjectName = useTranslatedText(extraerNombreMateria(subject.title), { titleCase: true });
  const seccion = extraerSeccion(subject.title);
  const subjectLabel = seccion ? `${subjectName} ${seccion}` : subjectName;
  const confirmMessage = `${confirmIntro.replace(/\?\s*$/, "")} "${subjectLabel}"?`;
  const subMessage = useTranslatedText(
    "Una vez que te hayas desinscripto perderás tu cupo para cursar dicha materia, esta acción no puede revertirse.",
  );
  const cancelLabel = useTranslatedText("Cancelar", { capitalize: true });
  const confirmLabel = useTranslatedText("Si, estoy seguro", { capitalize: true });

  const handleTrashSubject = async (idCurso: number, anioLectivo: number) => {
    setOpen(false);
    await unsubscribeSection(idCurso, anioLectivo);
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className="desktop-btn-unsuscribe-subject" disabled={isProcessing}>
        {isProcessing ? (
          <>
            <LiaSpinnerSolid className="spinner-animation" />{" "}
            <span className="mobile-no-text">
              <Translatable as="span" capitalize>Procesando</Translatable>
            </span>
          </>
        ) : (
          <>
            <SlIcon name="dash-lg" />
            <span className="mobile-no-text">
              <Translatable as="span" capitalize>Desinscribirme</Translatable>
            </span>
          </>
        )}
      </button>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        message={confirmMessage}
        subMessage={subMessage}
        topBorderWarn={true}
        closeButton={{
          label: cancelLabel,
          buttonFn: () => setOpen(false),
          color: "#F5A800",
        }}
        okButton={{
          label: confirmLabel,
          buttonFn: () => {
            handleTrashSubject(subject.idCurso, subject.anioLectivo);
          },
          color: "#F5A800",
        }}
      />
    </>
  );
}
